'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var main = require('../node_modules/zxcvbn/lib/main.js');
var Typography = require('@material-ui/core/Typography');
var Tooltip = require('@material-ui/core/Tooltip');
var InputAdornment = require('@material-ui/core/InputAdornment');
var TextField = require('@material-ui/core/TextField');
var IconButton = require('@material-ui/core/IconButton');
var VisibilityIcon = require('@material-ui/icons/Visibility');
var VisibilityOffIcon = require('@material-ui/icons/VisibilityOff');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var VisibilityIcon__default = /*#__PURE__*/_interopDefaultLegacy(VisibilityIcon);
var VisibilityOffIcon__default = /*#__PURE__*/_interopDefaultLegacy(VisibilityOffIcon);

var _excluded = ["value", "shouldDetectCapsLock", "scoreMessages", "tooShortMessage", "minLength", "detectPasswordStrength", "label", "error", "userInputs", "minScore"];
var propTypes = {
  /** Update callback */
  onChange: index.func.isRequired,
  shouldDetectCapsLock: index.bool,
  value: index.string,

  /** Minimum password length */
  minLength: index.number,

  /** Minumum security score */
  minScore: index.number,
  scoreMessages: index.arrayOf(index.string),
  scoreColors: index.arrayOf(index.string),
  tooShortMessage: index.string,
  userInputs: index.arrayOf(index.string),
  detectPasswordStrength: index.bool,
  label: index.string,
  error: index.any
};
var defaultProps = {
  value: '',
  shouldDetectCapsLock: true,
  minLength: 8,
  minScore: 2,
  scoreMessages: ['Bad', 'Weak', 'Okay', 'Good', 'Strong'],
  tooShortMessage: 'Too Short',
  userInputs: [],
  detectPasswordStrength: false,
  label: 'Password'
};

var isTooShort = (password, minLength) => password.length < minLength;

class PasswordField extends React__default['default'].Component {
  constructor() {
    super(...arguments);

    _rollupPluginBabelHelpers.defineProperty(this, "state", {
      passwordIsVisible: false,
      capsLockOn: false,
      score: 0,
      isValid: false
    });

    _rollupPluginBabelHelpers.defineProperty(this, "handleChange", event => {
      var {
        detectPasswordStrength
      } = this.props;
      var password = event.target.value;

      if (detectPasswordStrength) {
        this.updatePassword(password);
      } else {
        this.props.onChange(password, true);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(this, "updatePassword", password => {
      var {
        onChange,
        minScore,
        minLength,
        userInputs
      } = this.props;
      var score = 0;

      if (!isTooShort(password, minLength)) {
        var result = main(password, userInputs);
        score = result.score;
      }

      var isValid = score >= minScore;
      this.setState({
        isValid,
        score
      }, () => onChange(password, isValid));
    });

    _rollupPluginBabelHelpers.defineProperty(this, "componentDidMount", () => {
      if (this.props.shouldDetectCapsLock) {
        window.addEventListener('keydown', this.handleDetectCapsLocks);
        window.addEventListener('keyup', this.handleDetectCapsLocks);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(this, "componentWillUnmount", () => {
      if (this.props.shouldDetectCapsLock) {
        window.removeEventListener('keydown', this.handleDetectCapsLocks);
        window.removeEventListener('keyup', this.handleDetectCapsLocks);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(this, "handleDetectCapsLocks", event => {
      if (!(event !== null && event !== void 0 && event.getModifierState)) {
        return;
      }

      var capsLockOn = event.getModifierState('CapsLock');

      if (capsLockOn !== this.state.capsLockOn) {
        this.setState({
          capsLockOn
        });
      }
    });

    _rollupPluginBabelHelpers.defineProperty(this, "togglePasswordVisibility", () => this.setState({
      passwordIsVisible: !this.state.passwordIsVisible
    }));

    _rollupPluginBabelHelpers.defineProperty(this, "render", () => {
      var _textFieldProps$Input;

      var _this$props = this.props,
          {
        value,
        shouldDetectCapsLock,
        scoreMessages,
        tooShortMessage,
        minLength,
        detectPasswordStrength,
        label,
        error,
        // eslint-disable-next-line
        userInputs,
        // eslint-disable-next-line
        minScore
      } = _this$props,
          textFieldProps = _rollupPluginBabelHelpers.objectWithoutProperties(_this$props, _excluded);

      var {
        passwordIsVisible,
        capsLockOn,
        score
      } = this.state;
      var passwordIsTooShort = isTooShort(value, minLength);
      return /*#__PURE__*/React__default['default'].createElement(Tooltip__default['default'], {
        placement: "right",
        title: shouldDetectCapsLock && capsLockOn ? 'Caps lock is ON' : '',
        open: shouldDetectCapsLock && capsLockOn
      }, /*#__PURE__*/React__default['default'].createElement(TextField__default['default'], _rollupPluginBabelHelpers['extends']({}, textFieldProps, {
        label: label,
        value: value,
        error: error,
        onChange: this.handleChange,
        type: passwordIsVisible ? 'text' : 'password',
        InputProps: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, textFieldProps.InputProps), {}, {
          endAdornment: /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, (_textFieldProps$Input = textFieldProps.InputProps) === null || _textFieldProps$Input === void 0 ? void 0 : _textFieldProps$Input.endAdornment, /*#__PURE__*/React__default['default'].createElement(InputAdornment__default['default'], {
            position: "end"
          }, detectPasswordStrength && !!value.length && /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
            variant: "caption",
            noWrap: true,
            color: score >= 3 ? 'primary' : score === 2 ? 'secondary' : value.length ? 'error' : 'textPrimary'
          }, passwordIsTooShort ? tooShortMessage : scoreMessages[score]), /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
            onClick: this.togglePasswordVisibility,
            tabIndex: -1
          }, passwordIsVisible ? /*#__PURE__*/React__default['default'].createElement(VisibilityIcon__default['default'], null) : /*#__PURE__*/React__default['default'].createElement(VisibilityOffIcon__default['default'], null))))
        })
      })));
    });
  }

}
PasswordField.propTypes = propTypes;
PasswordField.defaultProps = defaultProps;

exports.PasswordField = PasswordField;
exports.default = PasswordField;
